var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cms-post-meta",
      class: ["cms-post-meta--" + (_vm.size || "small")],
      style: { textAlign: _vm.align || "left" },
    },
    [
      _vm._l(_vm.parts, function (part, i) {
        return [
          i > 0
            ? _c(
                "span",
                {
                  key: "sep-" + i,
                  staticClass: "cms-post-meta__sep",
                  attrs: { "aria-hidden": "true" },
                },
                [_vm._v(_vm._s(_vm.separator || "·"))]
              )
            : _vm._e(),
          _vm._v(" "),
          part.url
            ? _c(
                "a",
                {
                  key: "p-" + i,
                  staticClass: "cms-post-meta__part",
                  class: "cms-post-meta__part--" + part.kind,
                  attrs: { href: part.url },
                },
                [_vm._v(_vm._s(part.text))]
              )
            : _c(
                "span",
                {
                  key: "p-" + i,
                  staticClass: "cms-post-meta__part",
                  class: "cms-post-meta__part--" + part.kind,
                },
                [_vm._v(_vm._s(part.text))]
              ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }